// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1eVfQ","footer":"ReportModalFilter_footer__14n_X"};